export const useLocalStorage = () => {
  const { localStorage } = window;

  /**
   * Sets an item in local storage
   * @param key sets the key for item in local storage
   * @param value sets the value for item in local storage (can be string, object, array, etc.)
   */
  const setItem = <T>(key: string, value: T) => {
    const stringifiedValue = JSON.stringify(value);
    localStorage.setItem(key, stringifiedValue);
  };

  /**
   * Get an item from local storage
   * @param key key to get the item from
   * @returns parsed value from local storage or null
   */
  const getValue = <T>(key: string): T | null => {
    const storedValue = localStorage.getItem(key);
    if (storedValue) {
      return JSON.parse(storedValue) as T;
    }
    return null;
  };

  /**
   * Remove an item from local storage
   * @param key key of item
   */
  const removeItem = (key: string) => {
    localStorage.removeItem(key);
  };

  return {
    setItem,
    getValue,
    removeItem,
  };
};
